import React from 'react';
import { oneOf, string, bool } from 'prop-types';
import MuiAvatar from '@mui/material/Avatar';
import { AvatarWrapper } from './Avatar.styles';
export const getInitials = function () {
  let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const splitName = name.split(/[-\s]+/).slice(0, 2);
  if (splitName.length > 1) {
    var _splitName$, _splitName$$charAt, _splitName$2, _splitName$2$charAt;
    const initials = "".concat((_splitName$ = splitName[0]) === null || _splitName$ === void 0 ? void 0 : (_splitName$$charAt = _splitName$.charAt(0)) === null || _splitName$$charAt === void 0 ? void 0 : _splitName$$charAt.toUpperCase()).concat((_splitName$2 = splitName[1]) === null || _splitName$2 === void 0 ? void 0 : (_splitName$2$charAt = _splitName$2.charAt(0)) === null || _splitName$2$charAt === void 0 ? void 0 : _splitName$2$charAt.toUpperCase());
    return initials;
  }
  return name.length ? name.charAt(0) : null;
};
export const Avatar = _ref => {
  let {
    imageAlt,
    imageUrl,
    name,
    variant,
    size,
    backgroundColor,
    hasBorder,
    hasElevation
  } = _ref;
  return /*#__PURE__*/React.createElement(AvatarWrapper, {
    size: size,
    backgroundColor: backgroundColor,
    hasBorder: hasBorder,
    hasElevation: hasElevation
  }, /*#__PURE__*/React.createElement(MuiAvatar, {
    alt: imageAlt,
    "data-test-id": "avatar",
    src: imageUrl,
    variant: variant
  }, getInitials(name)));
};
Avatar.propTypes = {
  imageAlt: string,
  imageUrl: string,
  name: string,
  variant: oneOf(['circular', 'rounded', 'square']),
  size: oneOf(['large', 'medium-large', 'medium', 'small']),
  backgroundColor: oneOf(['blue', 'green', 'purple', 'white']),
  hasBorder: bool,
  hasElevation: bool
};
Avatar.defaultProps = {
  imageAlt: 'Profile Photo',
  imageUrl: '',
  name: '',
  variant: 'circular',
  size: 'medium',
  backgroundColor: 'purple',
  hasBorder: false,
  hasElevation: false
};